import { ChevronRight } from "lucide-react";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const SapServices = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });
  }, [location.pathname]);

  return (
    <div className="lg:col-span-1">
      <div className="sticky top-3">
        <div className="bg-white rounded-xl shadow-soft overflow-hidden mb-10">
          <div className="p-1 bg-primary"></div>
          <div className="lg:mb-20 p-6">
            <h3 className="text-xl font-bold text-blue-700 mb-4">
              <Link to="/services/sap-services">SAP Services</Link>
            </h3>
            <ul className="space-y-2">
              {[
                { path: "sap-successfactors", label: "Sucess Factors" },
                { path: "sap-btp", label: "Business Technology Platform" },
              ].map((item, index) => (
                <li key={index} className="border-b border-gray-100 pb-2">
                  <Link
                    to={`/services/sap-services/${item.path}`}
                    className={`flex items-center ${
                      location.pathname.includes(item.path)
                        ? "text-primary text-blue-700"
                        : "text-gray-600"
                    } hover:text-primary transition-colors font-medium`}
                  >
                    <ChevronRight />
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="lg:mt-20 bg-gradient-to-r from-primary bg-blue-700 to-blue-700 text-white rounded-xl shadow-soft overflow-hidden">
          <div className="p-6">
            <h3 className="text-xl font-bold mb-4">
              Don't hesitate to contact us
            </h3>
            <ul className="space-y-5">
              <li className="flex items-start">
                <div className="bg-white bg-opacity-20 p-2 rounded-full mr-3 flex-shrink-0">
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <span className="block text-sm text-blue-100">Call Us</span>
                  <a
                    href="tel:+1-512-203-7627"
                    className="font-medium hover:underline"
                  >
                    +1-512-203-7627
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-white bg-opacity-20 p-2 rounded-full mr-3 flex-shrink-0">
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <span className="block text-sm text-blue-100">
                    Write to Us
                  </span>
                  <a
                    href="mailto:connect@tissatech.com"
                    className="font-medium hover:underline"
                  >
                    connect@tissatech.com
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-white bg-opacity-20 p-2 rounded-full mr-3 flex-shrink-0">
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    ></path>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <span className="block text-sm text-blue-100">
                    Office Location
                  </span>
                  <p className="font-medium">
                    2001 Timberloch Place, Suite 500 Woodlands, Houston, Texas
                    77380
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SapServices;
